export default "__VITE_ASSET__CtKUnc3U__"